import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { automations } from 'modules/automations/store/collections/automations'
import type { Automation } from 'modules/automations/store/models/Automation'

interface Props {
  automationId: string
  onClose: () => void
}

const RenameAutomationModal = ({ automationId, onClose }: Props) => {
  const automation = React.useMemo<Automation>(() => {
    const automation = automations.find({
      id: automationId,
    })

    if (!automation) {
      throw new Error(`Missing automation with id: ${automationId}`)
    }

    return automation
  }, [automationId])

  const form = React.useMemo(
    () =>
      new Form(
        {
          name: automation?.attributes.name,
        },
        {
          name: 'string',
        }
      ),
    [automation]
  )

  const onSubmit = async (closePortal: ClosePortalFn) => {
    if (!automation) return

    const { success } = await asyncAction(() => automation.save(form.data()))

    if (success) closePortal()
  }

  return (
    <Modal
      illustration="calendar"
      title={i18n.t('automations.automation.rename.title')}
      description={i18n.t('automations.automation.rename.description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={<Button submit>{i18n.t('common.save')}</Button>}
    >
      <Text label={i18n.t('automations.automation.rename.name')} field={form.get('name')} />
    </Modal>
  )
}

export default RenameAutomationModal
